import { TableContainer, Table, SxProps, Theme } from "@mui/material";
import CardBox from "../CardBox";
import RopTableHeader from "../RopTable/RopTableHeader";
import { TableItem } from "../RopTable/RopTable";
import RopTableCollapsibleBody, { CollapsibleTableRowType } from "./RopTableCollapsibleBody";

export type RopCollapsibleTableProps = {
    hover?: boolean;
    itemsHeaders?: TableItem[];
    items?: CollapsibleTableRowType[];
    isLoading?: boolean;
    maxHeigth?: number | string;
    sxCardBox?: SxProps<Theme>;
    title?: string;
    historyTableColSpan?: number;
    historyTableCellSx?: SxProps<Theme>;
    saveCollapsable?: boolean;
    initialSelectedItem?: string;
};

export default function RopCollapsibleTable(props: RopCollapsibleTableProps) {
    return (
        <>
            <CardBox
                sx={{
                    width: "calc(100% - 20px)",
                    maxHeight: { sm: props.maxHeigth ?? "85vh" },
                    display: "flex",
                    flexDirection: "column",
                    margin: "10px",
                    ...props.sxCardBox,
                }}
            >
                <TableContainer>
                    <Table aria-label="simple table" sx={{
                        tableLayout: "fixed",
                        width: "100%",
                    }}>
                        <RopTableHeader itemsHeaders={props.itemsHeaders || []} />
                        <RopTableCollapsibleBody
                            hover={props.hover}
                            isLoading={props.isLoading}
                            collapsibleTable={props.items}
                            itemsHeaders={props.itemsHeaders}
                            title={props.title}
                            historyTableColSpan={props.historyTableColSpan}
                            historyTableCellSx={props.historyTableCellSx}
                            saveCollapsable={props.saveCollapsable}
                            initialSelectedItem={props.initialSelectedItem}
                        />
                    </Table>
                </TableContainer>
            </CardBox>
        </>
    );
}
